import { createAction, props } from '@ngrx/store';
import { Signin } from '../signin.interface';

export const receivedMaxisToken = createAction(
  '[Redirect] Received Maxis SSO Token',
  props<{code: string}>()
);

export const unconfirmedAccount = createAction(
  '[Redirect] Customer Account Not Confirmed',
  props<{data: { Token: string; UUID: string; }}>()
);

export const authenticationSuccess = createAction(
  '[Redirect] Authentication Successful',
  props<{data: Signin}>()
);

// export const loadRedirectsSuccess = createAction(
//   '[Redirect] Load Redirects Success',
//   props<{ data: any }>()
// );

export const loadRedirectsNoCode = createAction(
  '[Redirect] No Authentication Code'
);

export const authenticationFailure = createAction(
  '[Redirect] Failed To Authenticate'
);

export const authGuardRedirect = createAction(
  '[AuthGuard] Unauthorized Access',
  props<{data: string}>()
);
